import { render, staticRenderFns } from "./stayWriteOffProve.vue?vue&type=template&id=f01c9c64"
import script from "./stayWriteOffProve.vue?vue&type=script&lang=js"
export * from "./stayWriteOffProve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports